export namespace Helper {
    export function formatDate(date: string) {
        const options: Intl.DateTimeFormatOptions = { weekday: "short", day: "2-digit", month: "long", year: "numeric" };
        const locales = "en-GB";

        const formatedDate = new Date(date).toLocaleDateString(locales, options);

        return formatedDate;
    }

    export function relativeDate(date: string) {
        const options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "2-digit", year: "numeric" };
        const locales = "en-GB";

        const formatedDate = new Date(date).toLocaleDateString(locales, options);

        return formatedDate;
    }

    export function getBuildNumber(version:string) {        
      const versionParts = version.split('.');
      const buildNumber = Number(versionParts[versionParts.length - 1]);

      return buildNumber;
    }
}
